import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { cashflowAdminRouter } from './routing/cashflowAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  cashflowPriceAuditControl,
  cashflowCheckoutDiscrepancyAuditControl,
  cashflowTransactionIntegrityAuditControl,
} from './access-control/cashflowAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'cashflow',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'cashflow-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [cashflowAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-cashflow-price-audit-landing',
          labelId: 'cashflowDomain.priceAudit.title',
          accessControl: cashflowPriceAuditControl,
        },
        {
          route: 'app-admin-cashflow-checkout-discrepancy-audit-landing',
          labelId: 'cashflowDomain.checkoutDiscrepancyAudit.title',
          accessControl: cashflowCheckoutDiscrepancyAuditControl,
        },
        {
          route: 'app-admin-cashflow-transaction-integrity-audit',
          labelId: 'cashflowDomain.transactionIntegrityAudit.title',
          accessControl: cashflowTransactionIntegrityAuditControl,
        },
        {
          route: 'app-admin-cashflow-golden-receipt',
          labelId: 'cashflowDomain.goldenReceipt.title',
          accessControl: cashflowPriceAuditControl,
        },
      ],
    },
  ],
}

export default definition
